import React from "react";
import HistoricalDescription from "./HistoricalDescription";
import { FaMagic } from "@react-icons/all-files/fa/FaMagic";
import { NormalText } from "@components/styles/dataDisplay";

type HistoricalDescriptionTranslationProps = {
  descriptionTranslation?: string;
  openModal: () => void;
};

const HistoricalDescriptionTranslation: React.FC<HistoricalDescriptionTranslationProps> = ({
  openModal,
  descriptionTranslation,
}) => {
  if (!descriptionTranslation) return null;

  return (
    <div style={{ marginTop: 16, display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", alignItems: "center", columnGap: 8 }}>
        <FaMagic size={12} />
        <NormalText semiBold>Interpretação da Inteligência Artificial</NormalText>
      </div>
      <HistoricalDescription openModal={openModal} eventDescription={descriptionTranslation} />
    </div>
  );
};

export default HistoricalDescriptionTranslation;
